<template id="background">
  <div id="app">
    <div v-if="!loading">
      <router-view />
    </div>
    <div v-else>
      <div class="espera">
        <img src="@/assets/logo.png" alt="" />
        <br />
        <img src="@/assets/espera.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },
  beforeCreate() {
    this.$store.dispatch("fetchAllData");
  },
};
</script>
<style lang="scss">
:root {
  --background: rgb(0, 29, 68);
  --background-gradient: linear-gradient(
    187deg,
    rgba(0, 29, 68, 1) 0%,
    rgba(3, 56, 131, 1) 100%
  );
  --black: #000;
  --white: #fff;
  --font-sans-serif: Avenir, Helvetica, Arial, sans-serif;
  --border-radius: 15px;
}
* {
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.container {
  position: relative;
  margin: auto;
}
html {
  font-size: 16px;
}
body {
  font-size: 1rem;
  background-color: #0c1028;
  margin: 0;
}
p {
  margin: 0;
  padding: 0;
}

.espera {
  background-color: #2a4040;
  width: 100vw;
  height: 100vh;
}

button {
  cursor: pointer;
}

.night {
  .menu {
    p {
      color: white !important;
    }
    button {
      color: white !important;
      border-color: white !important;
    }
    .bubble {
      border-color: white !important;
    }
    svg {
      path {
        stroke: white;
      }
      circle {
        stroke: white;
        stroke-width: 1px;
      }
    }
  }
  .logorelative {
    path,
    circle {
      stroke: white !important;
    }
  }
  .slide {
    border-color: white !important;
  }
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
